import script from "./OrderShipToMultiple.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderShipToMultiple.vue?vue&type=script&setup=true&lang=js"

import "./OrderShipToMultiple.vue?vue&type=style&index=0&id=6760ffa0&lang=scss"

const __exports__ = script;

export default __exports__